function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var EMPTY_SUBSCRIPTION = {
  unsubscribe: function unsubscribe() {
    return undefined;
  }
};
var Emitter =
/*#__PURE__*/
function () {
  function Emitter() {
    this.consumers = new Map();
  }

  var _proto = Emitter.prototype;

  _proto.subscribe = function subscribe(consumer) {
    if (!consumer) {
      return EMPTY_SUBSCRIPTION;
    }

    var consumerKey = Object.create(null);
    this.consumers.set(consumerKey, consumer);
    return new EmitterSubscription(this.consumers, consumerKey);
  };

  _proto.emit = function emit(value) {
    if (this.consumers.size === 0) {
      return;
    }

    this.consumers.forEach(function (consumer) {
      return consumer(value);
    });
  };

  _proto.clear = function clear() {
    this.consumers.clear();
    this.consumers = new Map();
  };

  _createClass(Emitter, [{
    key: "size",
    get: function get() {
      return this.consumers.size;
    }
  }]);

  return Emitter;
}();

var EmitterSubscription =
/*#__PURE__*/
function () {
  function EmitterSubscription(consumers, consumerKey) {
    this.consumers = consumers;
    this.consumerKey = consumerKey;
  }

  var _proto2 = EmitterSubscription.prototype;

  _proto2.unsubscribe = function unsubscribe() {
    if (this.consumers && this.consumerKey) {
      this.consumers["delete"](this.consumerKey);
    }

    this.consumers = undefined;
    this.consumerKey = undefined;
  };

  return EmitterSubscription;
}();

export { Emitter };
